import React from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./FinalCTA.css";

export default function FinalCTA() {
  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".final-cta__title span"), {
      yPercent: 110,
      opacity: 0,
      duration: 0.9,
      stagger: 0.08,
      ease: "power4.out",
      scrollTrigger: { trigger: el, start: "top 75%" },
    });
  }, []);

  return (
    <section className="final-cta" ref={sectionRef}>
      <div className="final-cta__sun" aria-hidden="true" />
      <div className="final-cta__rays" aria-hidden="true" />
      <div className="container final-cta__content">
        <h2 className="final-cta__title">
          <span>READY TO</span>
          <span className="glow-text">SWITCH ON?</span>
        </h2>
        <p>Let&rsquo;s build a smarter energy future together.</p>
        <div className="final-cta__buttons">
          <Link to="/contact" className="btn btn-primary">
            Get A Solar Quote
          </Link>
          <Link to="/contact" className="btn btn-outline">
            Contact Selectra
          </Link>
        </div>
      </div>
    </section>
  );
}
